"use strict";

exports.__esModule = true;
exports.default = exports.ImageSelectionBuilder = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("@jsluna/button");

var _form = require("@jsluna/form");

var _grid = require("@jsluna/grid");

var _icons = require("@jsluna/icons");

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ImageSelectionBuilder = function ImageSelectionBuilder(_ref) {
  var id = _ref.id,
      name = _ref.name,
      editable = _ref.editable,
      onImageSelectionOptionUpdated = _ref.onImageSelectionOptionUpdated;

  var _useState = (0, _react.useState)([]),
      imageSelectionOptions = _useState[0],
      setImageSelectionOptions = _useState[1];

  var onImageChange = function onImageChange(e) {
    var file = e.target.files[0];

    if (file !== undefined && imageSelectionOptions.length < 8) {
      switch (file.type) {
        case _constants.FILE_TYPE_IMAGE_PNG:
        case _constants.FILE_TYPE_IMAGE_JPEG:
        case _constants.FILE_TYPE_IMAGE_GIF:
          // eslint-disable-next-line no-case-declarations
          var reader = new FileReader();

          reader.onloadend = function () {
            setImageSelectionOptions([].concat(imageSelectionOptions, [{
              file: file,
              imagePreviewUrl: reader.result,
              imageTitle: '',
              imageNumber: imageSelectionOptions.length + 1
            }]));
            onImageSelectionOptionUpdated(imageSelectionOptions);
          };

          reader.readAsDataURL(file);
          break;

        default:
          break;
      }
    }
  };

  var onReplaceImage = function onReplaceImage(e, imageNumber) {
    var file = e.target.files[0];

    switch (file.type) {
      case _constants.FILE_TYPE_IMAGE_PNG:
      case _constants.FILE_TYPE_IMAGE_JPEG:
      case _constants.FILE_TYPE_IMAGE_GIF:
        // eslint-disable-next-line no-case-declarations
        var reader = new FileReader();

        reader.onloadend = function () {
          var updatedImage = imageSelectionOptions.map(function (option) {
            if (option.imageNumber === imageNumber) {
              var assignedOption = Object.assign({}, option);
              assignedOption.file = file;
              assignedOption.imagePreviewUrl = reader.result;
              return assignedOption;
            }

            return option;
          });
          updateOptionsState(updatedImage);
        };

        reader.readAsDataURL(file);
        break;

      default:
        break;
    }
  };

  var onRemoveImage = function onRemoveImage(imageNumber) {
    var newOptions = imageSelectionOptions.filter(function (option) {
      return option.imageNumber !== imageNumber;
    });
    newOptions.map(function (option, i) {
      return option.imageNumber = i + 1;
    });
    updateOptionsState(newOptions);
  };

  var handleInput = function handleInput(e, imageNumber) {
    var updatedTitle = imageSelectionOptions.map(function (option) {
      if (option.imageNumber === imageNumber) {
        var assignedOption = Object.assign({}, option);
        assignedOption.imageTitle = e.target.value;
        return assignedOption;
      }

      return option;
    });
    updateOptionsState(updatedTitle);
  };

  var updateOptionsState = function updateOptionsState(options) {
    setImageSelectionOptions(options);
    onImageSelectionOptionUpdated(options);
  };

  var questionContainerId = "questionContainer" + id;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    type: "file",
    id: questionContainerId,
    style: {
      display: 'none'
    },
    name: name,
    accept: "image/*",
    onChange: function onChange(e) {
      return onImageChange(e);
    }
  }), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, {
    verticalAlign: "middle",
    style: {
      paddingBottom: '0.5rem'
    }
  }, imageSelectionOptions.map(function (option) {
    var optionContainerId = id + option.imageNumber;
    return /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: {
        xl: '1/2',
        md: '1/1'
      },
      key: option.imageNumber
    }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/3"
    }, option.file !== undefined && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "image-holder"
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "img-holder",
      src: option.imagePreviewUrl,
      className: "image"
    })), /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
      type: "file",
      id: optionContainerId,
      style: {
        display: 'none'
      },
      name: name,
      accept: "image/*",
      onChange: function onChange(e) {
        return onReplaceImage(e, option.imageNumber);
      }
    }))), option.file !== undefined && /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "2/3"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: {
        default: '1/1',
        sm: '1/1'
      }
    }, /*#__PURE__*/_react.default.createElement("h1", null, option.imageNumber)), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: {
        default: '1/1',
        sm: '1/1'
      }
    }, /*#__PURE__*/_react.default.createElement(_form.TextInput, {
      disabled: !editable,
      onChange: function onChange(e) {
        return handleInput(e, option.imageNumber);
      },
      maxLength: 250,
      placeholder: "Enter image title"
    })), editable && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: {
        default: '3/4',
        sm: '3/4'
      }
    }, /*#__PURE__*/_react.default.createElement(_button.LinkButton, {
      onClick: function onClick(e) {
        return document.getElementById(optionContainerId).click(e);
      },
      name: name
    }, "Replace Image")), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: {
        default: '1/4',
        sm: '1/4'
      }
    }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
      onClick: function onClick() {
        return onRemoveImage(option.imageNumber);
      },
      style: {
        width: '60px'
      },
      label: "Delete",
      hideLabel: true
    }, /*#__PURE__*/_react.default.createElement(_icons.Delete, null)))))));
  })), editable && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    onClick: function onClick() {
      return document.getElementById(questionContainerId).click();
    },
    name: name
  }, "Upload images")));
};

exports.ImageSelectionBuilder = ImageSelectionBuilder;
ImageSelectionBuilder.propTypes = {
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  editable: _propTypes.default.bool.isRequired,
  onImageSelectionOptionUpdated: _propTypes.default.func.isRequired
};
var _default = ImageSelectionBuilder;
exports.default = _default;